export default {
  namespaced: true,

  state: {
    drawerVisible: false,
  },

  mutations: {
    setDrawerVisible(state, drawerVisible) {
      state.drawerVisible = drawerVisible;
    }
  }
}